import api from '@/API';
import { IntegrationType, ServiceAccount } from '../../types';

export function regenerateApiKey(id: number): Promise<string> {
  const endpoint = `service-accounts/${id}/api-keys`;
  return api
    .post(endpoint)
    .then(response => response.data.apiKey);
}
